import { useState, useEffect } from 'react';
import type { PlanType } from '../types/api';
import { billingService } from '../lib/services';

/**
 * Light hook to fetch the current user's subscription plan type.
 * Falls back to 'TRIAL' on any error.
 */
export function useBillingPlan() {
  const [planType, setPlanType] = useState<PlanType>('TRIAL');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await billingService.getSubscription();
        if (!cancelled && res?.data?.planType) setPlanType(res.data.planType);
      } catch {
        // keep default TRIAL
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return { planType, loading };
}
